import { apiClient } from '@/api/client';
import { Category } from '@/api/models';
import { useEntityDrawer } from '@/hooks/useEntityDrawer';
import { queryKeys } from '@/lib/queryKeys';
import { CategoryFormData } from '@/pages/categories/hooks/useCategoryMutations';
import * as React from 'react';
import { CategoryDrawerView } from './CategoryDrawerView';

export interface CategoryDrawerProps {
  onFormSubmit: (formData: CategoryFormData) => Promise<void>;
  onDeleteCategory: (category: Category) => void;
  isFormLoading: boolean;
}

export const CategoryDrawer: React.FC<CategoryDrawerProps> = ({
  onFormSubmit,
  onDeleteCategory,
  isFormLoading,
}) => {
  const { state, actions, isLoading } = useEntityDrawer<Category>({
    basePath: '/categories',
    queryKey: queryKeys.ADMIN_CATEGORIES,
    fetchFn: async (id: number) => {
      const response = await apiClient.GET('/admin/categories/{id}', {
        params: { path: { id } },
      });
      if (response.error) throw new Error('Failed to fetch category');
      return response.data as Category;
    },
    supportsCreate: true,
  });

  return (
    <CategoryDrawerView
      isOpen={state.isOpen}
      category={state.entity}
      mode={state.mode}
      isLoading={isLoading}
      isFormLoading={isFormLoading}
      onClose={actions.close}
      onEdit={category => actions.edit(category.id!)}
      onDelete={onDeleteCategory}
      onFormSubmit={onFormSubmit}
    />
  );
};
